import { render, staticRenderFns } from "./add-or-update-meeting.vue?vue&type=template&id=264483ed&scoped=true"
import script from "./add-or-update-meeting.vue?vue&type=script&lang=js"
export * from "./add-or-update-meeting.vue?vue&type=script&lang=js"
import style0 from "./add-or-update-meeting.vue?vue&type=style&index=0&id=264483ed&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264483ed",
  null
  
)

export default component.exports